import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import StepShell from "../StepShell";

/**
 * Bloco 0 — Quem decide. Travado em UMA pessoa (responsável único). Vem
 * pré-preenchido com o admin logado; pode ajustar os dados, mas é sempre 1.
 */
export default function Bloco0Responsavel({ briefing, autosave }) {
  const [name, setName] = useState(briefing.responsibleName || "");
  const [whatsapp, setWhatsapp] = useState(briefing.responsibleWhatsapp || "");
  const [email, setEmail] = useState(briefing.responsibleEmail || "");

  return (
    <StepShell
      title="Quem decide a implantação?"
      description="Definimos UMA pessoa que decide e aprova. Implantação com vários sócios opinando é o que atrasa tudo."
    >
      <div className="mb-6 flex items-start gap-3 rounded-xl border border-border bg-surface-inset/50 p-4">
        <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-cyan-600 dark:text-cyan-400" />
        <p className="text-sm text-muted-foreground">
          Pré-selecionamos você como responsável. Ajuste os dados se necessário —
          mas mantemos um único ponto de decisão e aprovação.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-3">
        <div className="space-y-2">
          <Label htmlFor="resp-name">Nome do responsável</Label>
          <Input
            id="resp-name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              autosave({ responsibleName: e.target.value });
            }}
            placeholder="Nome completo"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="resp-whatsapp">WhatsApp</Label>
          <Input
            id="resp-whatsapp"
            value={whatsapp}
            onChange={(e) => {
              setWhatsapp(e.target.value);
              autosave({ responsibleWhatsapp: e.target.value });
            }}
            placeholder="(11) 99999-9999"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="resp-email">E-mail</Label>
          <Input
            id="resp-email"
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              autosave({ responsibleEmail: e.target.value });
            }}
            placeholder="email@escritorio.com"
          />
        </div>
      </div>
    </StepShell>
  );
}
